module.exports = __webpack_public_path__ + "static/media/18.73583528.jpg";